<template>
  <div id="tip">
    <div class="show">
      <div class="content">i</div>
    </div>
    <div class="tip-content" :style="{'width': width}" v-html="text"></div>
  </div>
</template>
<script>
export default {
  name: 'tip',
  props: {
    width: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
#tip  {
  position: relative;
  display: inline-block;
  cursor: pointer;
  /* top: -5px; */
}
#tip .show{
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  /* border: 1px solid #fff; */
  /* border-radius: 50%; */
  display: flex;
  justify-content: center;
  align-items: center;
}
#tip .show .content{
  width: 12px;
  height: 12px;
  border: 1px solid #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 12px;
  font-size: 10px;
  /* transform: scale(0.7); */
}
.newclassic #tip .show .content{
  color: #26272d;
  background: #6a6e74;
  border: 1px solid #6a6e74;
}
.newgrey #tip .show .content{
  color: #26272d;
  background: #6a6e74;
  border: 1px solid #6a6e74;
}
.newblack #tip .show .content{
  color: #f3f3fa;
  background: #757699;
  border: 1px solid #757699;
}
#tip:hover .tip-content {
  display: block;
}
#tip .tip-content {
  z-index: 99;
  /* font-size: 12px; */
  font-family: Microsoft YaHei;
  position: absolute;
  left: 20px;
  top: 20px;
  background: #131315;
  width: 280px;
  padding: 5px 20px;
  text-align: left;
  display: none;
  /* opacity: 0.9; */
  border:1px solid #484848
}
.newgrey #tip .tip-content{
  background: #181c21;
}
.newblack #tip .tip-content{
  background: #ffffff;
}
</style>